import { MapsLinkImportError } from './maps-link-import.error';

/** Maps errors to user-facing Spanish messages. */
export function googleMapsLinkErrorMessage(err: unknown): string {
  if (err instanceof MapsLinkImportError) {
    return err.message;
  }

  const code = (err as { code?: string })?.code;
  const message = (err as { message?: string })?.message ?? '';

  if (/referer restrictions/i.test(message)) {
    return (
      'La clave del servidor (GOOGLE_MAPS_API_KEY) tiene restricción por referentes HTTP. ' +
      'Usa una clave de servidor sin referentes o pega la URL larga de google.com/maps (ver ayuda arriba).'
    );
  }

  if (code === 'functions/unauthenticated') {
    return 'Inicia sesión para importar desde Google Maps.';
  }
  if (code === 'functions/not-found') {
    return message || 'No se pudo resolver el enlace. Comparte el enlace del lugar, no solo indicaciones.';
  }
  if (code === 'functions/invalid-argument') {
    return message || 'Enlace de Google Maps no válido.';
  }
  if (code === 'functions/failed-precondition') {
    return message || 'El servidor no tiene configurada la API de Google Maps.';
  }
  if (message.includes('internal')) {
    return 'Error del servidor al resolver el enlace. Prueba con la URL larga de google.com/maps.';
  }
  return message || 'No se pudo importar el enlace. Inténtalo de nuevo.';
}
